var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.55,169.43s-2.48,29.7,40,29.7m-31.17-29.85H97.55v-21.9h16.83ZM70.1,120s12.57-6.79,34.56-1.42c19.48,4.77,38.18-2.83,38.18-2.83m-.6-8.76H129.83m12.41-11.31H119.9m22.34,0H119.9m22.34-11.31H129.83m12.41,0H129.83M142.24,73H119.9m22.34,0H119.9m22.34-11.31H129.83m12.41,0H129.83m12.41-11.31H119.9m13,96.72H79.35a10.1,10.1,0,0,1-9.94-10.19V42.74a10.1,10.1,0,0,1,9.94-10.18H132.9a10.1,10.1,0,0,1,9.94,10.18v94.17A10.1,10.1,0,0,1,132.9,147.1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIv);
export default __webpack_public_path__ + "static/media/IV.2b9ec1bee34b89f3ff154e7347674f59.svg";
export { ForwardRef as ReactComponent };